<div *ngIf= "spinnerCheck === true && this.data.step != 'review'">
  <mat-spinner class="centered_spinner"></mat-spinner>
</div>

<div class="section-header" *ngIf= "voucherCheck == true && this.data.step != 'review'">Voucher Details</div>

<div class="section-body" *ngIf= "voucherCheck == true && this.data.step != 'review'">
  <p>
    It looks like there is a voucher associated with this unit. Upon completion of this move out action, what should the new voucher status
    be?
  </p>

  <mat-form-field appearance="outline">
    <mat-select [(ngModel)]="voucherstatus" (selectionChange)="checkPortOutSettings()">
      <mat-option *ngFor="let voucherstatus of voucherStatusList" [value]="voucherstatus">{{ voucherstatus.name }}</mat-option>
    </mat-select>
  </mat-form-field>

  <div *ngIf="voucherstatus.value == 'PORT_OUT'">
    <p flex="60">Please select a Housing Authority to port out to.</p>
    <p flex="60"><strong>Housing Authority*</strong></p>
      <p flex="60" class="ng-binding flex-60">
        <mat-form-field class="voucher-full-width">
            <input 
                type="text" 
                placeholder="Start typing the name of the Housing Authority"
                aria-label="Housing Authority" 
                matInput
                [formControl]="vendorCtrl" 
                [matAutocomplete]="vendorAuto"/>
            <mat-autocomplete #vendorAuto="matAutocomplete" [displayWith]="vendorSelectDisplay"  (optionSelected)="onVendorSelected($event)">
                <mat-option *ngFor="let ll of filteredVendors$ | async;" 
                    [value]="ll">
                    <span>{{ll.name}}</span>
                </mat-option>
            </mat-autocomplete>
        </mat-form-field>
      </p>
  </div>

</div>
